export const ADD_AMC_VIEWER = 'ADD_AMC_VIEWER';
export const ADD_AMC_VIEWER_SUCCESS = 'ADD_AMC_VIEWER_SUCCESS';
export const EDIT_AMC_VIEWER = 'EDIT_AMC_VIEWER';
export const EDIT_AMC_VIEWER_SUCCESS = 'EDIT_AMC_VIEWER_SUCCESS';
export const GET_AMC_VIEWERACCESS = 'GET_AMC_VIEWERACCESS';
export const GET_AMC_VIEWERACCESS_SUCCESS = 'GET_AMC_VIEWERACCESS_SUCCESS';
export const GET_AMC_VIEWERBYID = 'GET_AMC_VIEWERBYID';
export const GET_AMC_VIEWERBYID_SUCCESS = 'GET_AMC_VIEWERBYID_SUCCESS';
export const GET_AMC_VIEWER_LIST = 'GET_AMC_VIEWER_LIST';
export const GET_AMC_VIEWER_LIST_SUCCESS = 'GET_AMC_VIEWER_LIST_SUCCESS';
